import React from 'react';
import { useMousePosition } from '../../../../../../utils/hooks';
import { ZoneSelector } from '@weezevent/throne';
import HoverZone from './utils/HoverZone';
import ModalZone from './ModalZone';
import Seats from './Seatmap/utils/seats';
import LoadingCard from '../../../../../../components/loadingCard';

export default function ZonePicker({
    zones,
    categories = [],
    selectedZone,
    currentInventory,
    onBackToRoot,
    previousZone,
    popUp,
    form,
    showSeats,
    inventories,
    setShowSeats,
    setPopUp = () => {},
    hoveredZone,
    onSelectZone = () => {},
    setHoveredZone,
    loading,
    loadingZones,
    isBooking,
    currency,
    rates,
    sync,
    preview,
    selectedRates = [],
    onSelectRate = () => {},
    onAddAttendee = () => {},
    onSetRates = () => {}
}) {
    const { x, y } = useMousePosition();

    const handleBack = React.useCallback(() => {
        onSelectZone(previousZone);
    }, [onSelectZone, previousZone]);

    if (loading || isBooking || loadingZones) {
        return <LoadingCard loading />;
    }

    if (showSeats && !popUp) {
        return (
            <Seats
                availability={zones}
                currentInventory={currentInventory}
                categories={categories}
                onAddAttendee={onAddAttendee}
                onSelectRate={onSelectRate}
                loading={loading}
                inventories={inventories}
                onSetRates={onSetRates}
                onBackToRoot={onBackToRoot}
                previousZone={previousZone}
                form={form}
                sync={sync}
                rates={rates}
                currency={currency}
            />
        );
    }

    return (
        <>
            {hoveredZone && <HoverZone mouseX={x} mouseY={y} zone={hoveredZone} categories={categories} form={form} />}
            <ZoneSelector
                zone={zones?.children.length > 0 ? zones : previousZone}
                onZoneSelected={selected => onSelectZone(selected)}
                onZoneOver={setHoveredZone}
                showAvailability={false}
                unavailableColor={false}
                defaultColor="#0033fa"
                onBackButtonClicked={handleBack}
                mode3d={false}
                type={!preview && 'list'}
            />

            {popUp && !zones.children.length && (
                <ModalZone
                    zone={selectedZone}
                    availability={zones}
                    popUp={popUp}
                    setPopUp={setPopUp}
                    currency={currency}
                    rates={rates}
                    form={form}
                    sync={sync}
                    inventories={inventories}
                    isBooking={isBooking}
                    onBackToRoot={onBackToRoot}
                    setShowSeats={setShowSeats}
                    onSelectZone={onSelectZone}
                    selectedRates={selectedRates}
                    onSelectRate={onSelectRate}
                    onAddAttendee={onAddAttendee}
                    currentInventory={currentInventory}
                />
            )}
        </>
    );
}
